import React from "react";
import image1 from "../../assets/images/manufacturing/manufacturing-img-2.png";
import image2 from "../../assets/images/manufacturing/manufacturing-img-1.png";
import image3 from "../../assets/images/manufacturing/manufacturing-img-3.png";
import "./SwiperSection.css";

const steps = [
  {
    id: 0,
    image: image1,
    heading: "Import Design",
    description:
      "Quickly import your 3D models into our robotic welding software. The easy-to-use interface ensures models load smoothly, providing a clear view to help you easily prepare and set up your welding projects.",
  },
  {
    id: 1,
    image: image2,
    heading: "Mark",
    description:
      "Easily select the edges on your 3D model that you wish to weld. Clearly marking these paths helps the robotic welder precisely follow your instructions, ensuring accurate, neat, and consistent welding.",
  },
  {
    id: 2,
    image: image3,
    heading: "Start Weld",
    description:
      'Simply click "Weld" to instantly start the automated welding process. Our robotic welding software accurately follows your selected edges, completing your project efficiently, precisely and reliably.',
  },
];

const SwiperSection = () => {
  return (
    <section id="swiper-section" className="swiper-section">
      <div className="container">
        {steps.map((step, index) => (
          <div
            key={step.id}
            className="row align-items-center justify-content-between mb-5"
          >
            <div
              className={`col-lg-7 ${
                index % 2 === 0 ? "order-lg-2" : "order-lg-1"
              }`}
            >
              <img
                src={step.image}
                alt={step.heading}
                className="img-fluid rounded shadow slide-image"
              />
            </div>
            <div
              className={`col-lg-4 ${
                index % 2 === 0 ? "order-lg-1" : "order-lg-2"
              }`}
            >
              <h2 className="mb-3 swiper-heading">{step.heading}</h2>
              <p className="swiper-description">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SwiperSection;